var e={lineHeight:{value:1},height:{value:"1em"}};export{e as icon};
